import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/subdomain/')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
  component: () => null,
});
